export { ADMIN_PASSWORD, AUTH_KEY } from '../../common/adminAuth';
export const inputStyle = {
  width: '100%',
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(255,255,255,0.15)',
  borderRadius: '6px',
  padding: '12px 16px',
  color: '#fff',
  fontSize: '14px',
  outline: 'none',
};

export const cardStyle = {
  background: 'rgba(255,255,255,0.03)',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: '12px',
  overflow: 'hidden',
};

export const formBoxStyle = {
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: '12px',
};

export function TabButton({ active, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        padding: '10px 24px',
        borderRadius: '30px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        background: active ? 'var(--main-color)' : 'rgba(255,255,255,0.06)',
        color: '#fff',
        transition: 'background 0.2s',
      }}
    >
      {children}
    </button>
  );
}
